import React from 'react';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import {styled} from '@mui/material/styles';
import MuiAccordion, {AccordionProps} from '@mui/material/Accordion';
import MuiAccordionSummary, {AccordionSummaryProps} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import {ExpandMore} from '@mui/icons-material';
import {FAQContent, FAQ} from './FAQContent';
import theme from '../../theme/materialTheme';

const Subheading = styled(Typography)`
  &&& {
    padding-top: 1rem;
    padding-left: 1rem;
  }
`;

const Container = styled('div')`
  padding-top: ${SIZES['24']};
  width: 100%;
`;

const Accordion = styled((props: AccordionProps) => <MuiAccordion elevation={0} {...props} />)({
  '& .Mui-expanded': {
    backgroundColor: COLORS.lightestGrey,
  },
  '&.Mui-expanded': {
    marginTop: 0,
    boxShadow: theme.shadows[3],
  },
  '&:before': {
    display: 'none',
  },
});

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ExpandMore />} {...props} />
))({
  borderBottom: `1px dashed ${COLORS.lightGrey}`,
  '&:hover': {
    backgroundColor: COLORS.lightestGrey,
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: SIZES['4'],
  },
});

const AccordionDetails = styled(MuiAccordionDetails)({
  padding: SIZES['16'],
});

const faqLabels: Record<string, string> = {
  general: 'Allgemeine Informationen zu den Widgets',
  integration: 'Einbindung auf der Webseite',
  design: 'Styleanpassungen im Widget',
  error: 'Probleme und Fehler',
  data: 'Angezeigte Daten',
};

const Faq = () => {
  const [expanded, setExpanded] = React.useState<string | false>('panel1');

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  const faqsByGroup: Record<string, FAQ[]> = FAQContent.reduce((acc, FAQ) => {
    const category = FAQ.category || 'general';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(FAQ);
    return acc;
  }, {} as Record<string, FAQ[]>);

  const faqSection = Object.entries(faqsByGroup).map(([category, faqs]) => {
    const faqContent = faqs.map((faq, index) => {
      return (
        <Accordion
          key={`panel_${category}${index}`}
          expanded={expanded === `panel_${category}${index}`}
          onChange={handleChange(`panel_${category}${index}`)}>
          <AccordionSummary
            aria-controls={`panel_${category}${index}d-content`}
            id={`panel_${category}${index}d-header`}>
            <Typography variant='subheading'>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant={'subheading'}>
              <span dangerouslySetInnerHTML={{__html: faq.answer}} />
            </Typography>
          </AccordionDetails>
        </Accordion>
      );
    });

    return (
      <React.Fragment key={category}>
        <Subheading variant='subheading2' component='h3'>
          {faqLabels[category]}
        </Subheading>
        {faqContent}
      </React.Fragment>
    );
  });

  return <Container>{faqSection}</Container>;
};

export default Faq;
